import {
  GetMarketplaceIntegrationCountriesDocument,
  GetMarketplaceIntegrationCountriesQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useGetMarketplaceIntegrationCountries = (
  variables: GetMarketplaceIntegrationCountriesQueryVariables
) => {
  const { loading, data } = useQuery(GetMarketplaceIntegrationCountriesDocument, { variables })

  return {
    loading,
    data: data?.marketplace.integrationCountriesConnection.nodes || [],
  }
}
